module.exports = __webpack_public_path__ + "img/p.a9b23bd9.jpg";